import { IconScaleTwo } from '@vs-shop/ui/icons';
import { clsxm } from '@vs-shop/utils';
import { SearchX } from 'lucide-react';

import { getMemoizedIntlShapeWithDefaultLocale } from '../../utils/intl';

export default function ProductsComparisonEmpty() {
  const intl = getMemoizedIntlShapeWithDefaultLocale();

  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 pt-[5%] pb-[10%] text-center lap:gap-6">
      <SearchX className="h-14 w-14 stroke-1 text-foreground-muted lap:h-20 lap:w-20" />
      <div className={clsxm('font-heading', 'flex flex-col gap-2 lap:gap-4')}>
        {/* HEADING */}
        <span className="text-2xl text-foreground lap:text-3xl">
          {intl.formatMessage({
            id: 'productsComparison.empty.heading',
            defaultMessage: 'Porovnání neobsahuje žádné produkty',
          })}
        </span>

        {/* DESCRIPTION */}
        <span className="text-lg/6 text-foreground lap:text-xl/7">
          {intl.formatMessage(
            {
              id: 'productsComparison.empty.description',
              defaultMessage:
                'Pro zobrazení porovnání přidejte produkt pomocí ikony váhy {icon} u produktu.',
            },
            {
              icon: (
                <IconScaleTwo
                  key="icon"
                  className="mx-1.5 inline-block w-6 stroke-primary align-middle lap:w-7"
                />
              ),
            }
          )}
        </span>
      </div>
    </div>
  );
}
